import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthUser } from 'app/shared/models/class/auth/auth-user';
import { AuthService } from 'app/shared/services/auth/auth.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  @Input() user!: AuthUser;
  @Output() toggleDrawer = new EventEmitter<string>();


  constructor(
    private authSrv: AuthService
  ) { }

  ngOnInit() {
  }

  onLogout(): void {
    this.authSrv.logout();
    this.toggleDrawer.emit('logout');
  }

}
